import React, {Suspense, lazy} from 'react';
import {Spin} from 'antd';
import {authLoader} from '../../loader';
import {
  ROUTE_SECONDARY_DR_ALLOCATION_APPROVAL, ROUTE_SECONDARY_DR_ALLOCATION_ZSM_APPROVAL,
} from '@app/navigations/RoutePathConstant';

const SecondaryDrAllocationApproval = lazy(() =>
  import('../../../screens/SecondaryDrAllocationApproval')
    .then(module => ({default: module.SecondaryDrAllocationApproval})));

const SecondaryDrAllocationApprovalNavigation = [
  {
    path: ROUTE_SECONDARY_DR_ALLOCATION_APPROVAL,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <SecondaryDrAllocationApproval />
      </Suspense>
    ),
  },
  {
    path: ROUTE_SECONDARY_DR_ALLOCATION_ZSM_APPROVAL,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <SecondaryDrAllocationApproval />
      </Suspense>
    ),
  },
];

export default SecondaryDrAllocationApprovalNavigation;
